import React from 'react';
import {
  ActionList,
  ActionListItem,
  SelectInput,
  DropdownOverlay,
  Dropdown,
} from '@razorpay/blade/components';
import { portalStatus } from '../data';
import { RegisterGenericType } from 'forms/useRegister';
import { PortalStatus } from '../types';

export const PFStatusSelectInput = ({
  register,
  formData,
}: {
  register: RegisterGenericType<{ pfStatus: PortalStatus[] }>;
  formData: Partial<{ pfStatus: PortalStatus[] }>;
}) => {
  return (
    <Dropdown>
      <SelectInput
        label="Status"
        placeholder="Choose Status"
        {...register('pfStatus', 'select')}
        isRequired
        necessityIndicator="required"
      />
      <DropdownOverlay>
        <ActionList>
          <ActionListItem
            title="Registered Employee"
            value={portalStatus.registered}
            isSelected={formData.pfStatus?.[0] === portalStatus.registered}
          />
          <ActionListItem
            title="Not Registered"
            value={portalStatus.notRegistered}
            isSelected={formData.pfStatus?.[0] === portalStatus.notRegistered}
          />
          <ActionListItem
            title="Exit Employee"
            value={portalStatus.exit}
            isSelected={formData.pfStatus?.[0] === portalStatus.exit}
          />
        </ActionList>
      </DropdownOverlay>
    </Dropdown>
  );
};
